import type { PropsWithChildren } from 'react';
import React from 'react';

import './Alert.scss';

type AlertType = 'danger' | 'warning' | 'info' | 'success';
type AlertProps = {
  id?: string;
  type?: AlertType;
  role?: string;
};

function Alert({
  children,
  type = 'info',
  role = 'alert',
  ...other
}: PropsWithChildren<AlertProps>) {
  return (
    <div className={`Alert Alert--${type}`} role={role} {...other}>
      {children}
    </div>
  );
}

export { Alert, type AlertType };
